<div class="rs-maxh rs-padding-bottom2">
  <div class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh">
    <div class="rs-flex-row">
      <div class="rs-flex-columns">
        <h2 class="rs-tit5">
          {{ 'publicWifi.accountSection.title' | translate }}
        </h2>
      </div>
      <div class="rs-flex-columns" *ngIf="isPending">
        <px-loading-spinner></px-loading-spinner>
        <span class="show-for-sr">{{
          'publicWifi.accountSection.spinner.accessibility' | translate
        }}</span>
      </div>
    </div>
    <div class="rs-flex-row" *ngIf="!isPending && isAccountLoadedSuccess">
      <div class="rs-flex-columns small-12 medium-5">
        <mprd-public-wifi-account-list></mprd-public-wifi-account-list>
      </div>
      <div class="rs-flex-columns small-12 medium-7">
        <div class="rs-maxh rs-flex rs-flex-dir-col" *ngIf="isOwner">
          <p *ngIf="hasActiveAccount">
            <strong>{{ 'publicWifi.accountList.manage.title' | translate }}</strong>
          </p>
          <mprd-public-wifi-account-manage
            *ngFor="let account of accounts | publicWifiAccountFilter: true"
            [account]="account"
          ></mprd-public-wifi-account-manage>
          <mprd-public-wifi-account-create
            *ngFor="let account of accounts | publicWifiAccountFilter: false"
            [account]="account"
            [activeAccounts]="accounts | publicWifiAccountFilter: true"
          ></mprd-public-wifi-account-create>
        </div>
        <div class="rs-maxh rs-padding-bottom2" *ngIf="!isOwner">
          <div class="panel rs-maxh rs-no-margin rs-flex rs-flex-dir-col">
            <div class="rs-flex-row rs-flex-collapse">
              <div class="rs-flex-column rs-flex-shrink">
                <p>
                  <i
                    class="icon-Information-box icon-lh rs-txt-s7 rs-txt-purple rs-margin-right1"
                    aria-hidden="true"
                  ></i>
                </p>
              </div>
              <div class="rs-flex-column">
                <p class="rs-font-pxB rs-txt-purple">
                  {{ 'publicWifi.not.owner.title' | translate }}
                </p>
              </div>
            </div>
            <p class="rs-txt-s3">
              {{ 'publicWifi.not.owner.line.1' | translate }}
            </p>
            <p class="rs-txt-s3">
              {{ 'publicWifi.not.owner.line.2' | translate }}
            </p>
            <p class="rs-txt-s3">
              {{ 'publicWifi.not.owner.line.3' | translate }}
            </p>
            <div class="rs-flex-grow rs-flex rs-flex-bottom">
              <p class="rs-txt-s3">
                <a href="{{ 'publicWifi.not.owner.link' | translate }}">{{
                  'publicWifi.not.owner.line.4' | translate
                }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p *ngIf="!isPending && isAccountLoadedSuccess" class="hide-for-medium-up">
      <a href="{{ 'publicWifi.accountList.tnc.link' | translate }}" target="_blank">{{
        'publicWifi.accountList.tnc.label' | translate
      }}</a>
    </p>
  </div>
</div>
